(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name RegistroController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('RegistroController', RegistroController);

    RegistroController.$inject = ['RegistroService','UserService','$timeout'];


    function RegistroController(RegistroService,UserService,$timeout)
    {

      var vm = this;

      vm.step1 = true;
      vm.step2 = false;
      vm.step3 = false;
      vm.step4 = false;
      vm.loading = false;
      vm.errorRegister = false;
      vm.succesEdit = false;

      vm.datosContratoUser  = function(contratoValido){

         if (vm.contrato) {
            if (contratoValido == undefined && vm.step1) {
               var myModal = new bootstrap.Modal(document.getElementById('modalContrato'), {
                    keyboard: false
                  })

               myModal.show()

            }
         }
      }

      vm.registrar = function(form){

            if (vm.loading) {
               return;
            }

            if(form.$valid){
               vm.loading = true;
            }

            RegistroService.RegistroForm(vm).then(function(data){
               if(data.error){
                  vm.errorRegister = true;
               }else{
             
                  vm.contrato = data.contrato;
                  console.log(vm.contrato);
                  vm.loading = false;
                  vm.nuevoregistro = data.nuevoregistro;
                  vm.succesEdit =  true;
         
              
                  vm.step4 = true ; 
                  vm.step3 = false;
               }

           })
      }

         vm.editcompletado = function(){ 
           $timeout(function(){
             vm.succesEdit = !vm.succesEdit ;
           },

            3000)

           
        } 

      vm.getfacturas = function(init){ 
            UserService.anoFacturas(vm.filtros,function(data){
                vm.facturas = data.facturas;
                vm.anos = data.anos;
            });
        } 

       vm.firstFormValid = function(){ 
         
         if (vm.colegiado){
            vm.colegiadoValid = true;
            vm.colegiadoInvalid = false;
         }else{
            vm.colegiadoInvalid = true;
            vm.colegiadoValid = false;
         }
         
         if (vm.user_id){
            vm.user_idValid = true;
            vm.user_idInvalid = false;
         }else{
            vm.user_idInvalid = true;
            vm.user_idValid = false;
         }


         if (vm.acepto_datoscontrato){
            vm.acepto_datoscontratoInvalid = false;
         }else{
            vm.acepto_datoscontratoInvalid = true;
         }
         if (vm.colegiadoValid && vm.user_idValid && vm.acepto_datoscontrato) {
         } else {
            window.scrollTo({top: 0, behavior: 'smooth'});
         }


      }
      vm.firstFormValidSend = function(){ 
         if (vm.colegiado){
            vm.colegiadoValid = true;
            vm.colegiadoInvalid = false;
         }else{
            vm.colegiadoInvalid = true;
            vm.colegiadoValid = false;
         }
         
         if (vm.user_id){
            vm.user_idValid = true;
            vm.user_idInvalid = false;
         }else{
            vm.user_idInvalid = true;
            vm.user_idValid = false;
         }

         if (vm.acepto_datoscontrato){
            vm.acepto_datoscontratoInvalid = false;
         }else{
            vm.acepto_datoscontratoInvalid = true;
         }

         if (vm.colegiadoValid && vm.user_idValid && vm.acepto_datoscontrato) {
            vm.step3 = true;
            vm.step2 = false;
            window.scrollTo({top: 0, behavior: 'auto'});
         } else {
             window.scrollTo({top: 0, behavior: 'smooth'});
         }

      }

       vm.atras = function(){
         vm.step2 = true;
         vm.step3 = false
      }


      vm.avisoGuardar = function(){
         console.log("modal");
         var myModal = new bootstrap.Modal(document.getElementById('modalGuardar'), {
           keyboard: false
         })
              myModal.show()

      }
        
    }
})();